<template>
  <section class="flex-1 app-main d-flex">
    <transition class="flex-1" name="tree-transform" mode="out-in">
      <div v-show="showTree" class="project-tree">
        <el-radio-group v-model="treeType">
          <el-radio-button label="分组架构" />
          <el-radio-button
            v-show="yici_tree && yici_tree.length"
            label="一次架构"
          />
          <el-radio-button v-show="routeName === 'zhcx'" label="环境量" />
        </el-radio-group>
        <el-input
          v-model="tree_filterText"
          class="mt-2"
          prefix-icon="el-icon-search"
          placeholder="输入关键字进行过滤"
        />
        <div class="tree_box">
          <el-tree
            :key="selectTreeNode.GUID"
            ref="tree"
            class="filter-tree"
            :indent="10"
            node-key="GUID"
            :data="treeDta"
            :default-expanded-keys="defaultExpandedKeys"
            :current-node-key="selectTreeNode.GUID"
            :props="{
              children: 'Children',
              label: 'GName'
            }"
            :filter-node-method="filterNode"
            @node-click="handleNodeClick"
          />
        </div>
      </div>
    </transition>
    <transition class="flex-1" name="fade-transform" mode="out-in">
      <router-view :key="key" class="flex-1" />
    </transition>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'AppMain',
  data() {
    return {
      data: [],
      filterText: '',
      treeType: '分组架构'
    }
  },
  computed: {
    // 默认展开
    defaultExpandedKeys: function() {
      var defaultExpandedKeys = []
      if (this.selectTreeNode) {
        defaultExpandedKeys = [this.selectTreeNode.GUID]
      }
      return defaultExpandedKeys
    },
    ...mapState({
      treeDta: state => state['business/CommonService'].treeDta.Tree,
      showTree: state => state['business/CommonService'].showTree,
      selectTreeNode: state => state['business/CommonService'].selectTreeNode,
      yici_tree: state => state['business/CommonService'].yici_tree.Tree,
      selectProject: state => state.projects.selectProject
    }),
    tree_filterText: {
      get() {
        return this.$store.state['business/CommonService'].tree_filterText
      },
      set(n) {
        this.$refs.tree.filter(n)
        this.$store.commit('TREE_FILTER_TEXT', n)
      }
    },
    key() {
      return this.$route.path.split('/')[1]
    },
    routeName() {
      return this.$route.name
    }
  },
  watch: {
    treeType: function(newVal, oldVal) {
      if (newVal === '分组架构') {
        this.switchTree(0)
      } else if (newVal === '一次架构') {
        this.switchTree(1)
      } else {
        this.switchTree(2)
      }
    },
    selectProject: function(newVal, oldVal) {
      this.treeType = '分组架构'
    },
    treeDta: function(newVal, oldVal) {
      // console.log('选择的项目：', newVal)
      if (newVal.length > 0) {
        this.SetSelectTreeNode(newVal[0])
      }
    },
    '$route.name': function(newVal, oldVal) {
      this.treeType = '分组架构'
    }
  },
  mounted() {
    this.GetCommomTree()
  },

  methods: {
    ...mapActions(['GetCommomTree', 'SetSelectTreeNode', 'switchTree']),
    filterNode(value, data) {
      if (!value) return true
      return data.GName.indexOf(value) !== -1
    },
    // 选择树的某一个节点
    handleNodeClick(data) {
      this.SetSelectTreeNode(data)
      // this.$store.dispatch("projects/setSelectNode", data);
    }
  }
}
</script>
<style lang="scss">
  .el-tree {
    width: 100%;
  }
  .el-tree > .el-tree-node {
    display: inline-block;
    min-width: 100%;
  }
</style>
<style scoped lang="scss">
  .project-tree {
    width: vw(380);
    min-width: 240px;
    max-width: 340px;
    height: 100%;
    max-height: 100%;
    // overflow-y: auto;
    padding: 10px;
    background: #03182a;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .tree_box {
      margin-top: 20px;
      flex: 1;
      overflow: auto;
    }
    .filter-tree {
      // margin-top: 15px;
    }
  }
  .app-main {
    overflow: hidden;
    width: 100%;
    flex: 1;
    position: relative;
    transform-origin: 0% 0%;
    align-items: stretch;
  }
  .common-layout {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
</style>

<style lang="scss">
</style>
